import {RouteDefinition} from '../../../routes';
import {SetDateTimeScreen} from './SetDateTimeScreen';

export const SetDateTimeRoutes: RouteDefinition[] = [
    {
        routerLink: '/settings/set-date-time',
        component: SetDateTimeScreen,
    },
];
